import React, { useState } from "react";
import { FiMail, FiSend, FiGithub, FiCheck } from "react-icons/fi";

export default function Contact() {
  const [copied, setCopied] = useState(false);
  const email = "support@afterpartylabs.xyz";

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {}
  };

  return (
    <section className="min-h-[70vh] max-w-3xl mx-auto px-6 py-16 text-white">
      <header className="mb-8">
        <h1 className="text-4xl font-bold mb-2">Contact Us</h1>
        <p className="text-white/80">
          Got a question about our bots, need support, or want to collaborate?
          We’d love to hear from you.
        </p>
      </header>

      <div className="grid gap-4">
        {/* Email */}
        <div className="flex items-center justify-between bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl p-4 transition">
          <div className="flex items-center gap-3">
            <span className="p-2 rounded-xl bg-white/10"><FiMail /></span>
            <div>
              <div className="font-semibold">Email</div>
              <a
                className="text-blue-300 hover:underline break-all"
                href={`mailto:${email}?subject=Support%20Request%20-%20Afterparty%20BotLabs`}
                aria-label="Send an email to support at Afterparty BotLabs"
              >
                {email}
              </a>
            </div>
          </div>
          <button
            onClick={copyEmail}
            className="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-white/10 hover:bg-white/20"
            aria-label="Copy support email to clipboard"
          >
            {copied ? <FiCheck /> : <FiMail />} {copied ? "Copied" : "Copy"}
          </button>
        </div>

        {/* Discord */}
        <a
          href="https://discord.gg/afterpartylabs"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-between bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl p-4 transition"
          aria-label="Join our Discord support server (opens in new tab)"
        >
          <div className="flex items-center gap-3">
            <span className="p-2 rounded-xl bg-white/10"><FiSend /></span>
            <div>
              <div className="font-semibold">Discord</div>
              <div className="text-blue-300 hover:underline">Join our support server</div>
            </div>
          </div>
        </a>

        {/* GitHub */}
        <a
          href="https://github.com/botlabs-xyz"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-between bg-white/5 hover:bg-white/10 border border-white/10 rounded-2xl p-4 transition"
          aria-label="Visit our GitHub organization (opens in new tab)"
        >
          <div className="flex items-center gap-3">
            <span className="p-2 rounded-xl bg-white/10"><FiGithub /></span>
            <div>
              <div className="font-semibold">GitHub</div>
              <div className="text-blue-300 hover:underline break-all">github.com/botlabs-xyz</div>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
}